require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-167-cost-loaded-scheduling.json") })
        }
      }, "path---article-167-cost-loaded-scheduling");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-167-cost-loaded-scheduling!./.cache/json/article-167-cost-loaded-scheduling.json
// module id = 515
// module chunks = 231608221292675